var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB4Chronometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.39 25.33l4.39-4.57L59.89 18l-4.34 4.53A26.88 26.88 0 0040 16.08V11h8V7H28v4h8v5.08a26.88 26.88 0 00-15.55 6.43L16.11 18l-2.89 2.78 4.39 4.57a27 27 0 1040.78 0v-.02zM38 66a23 23 0 110-46 23 23 0 010 46zm19-25v4h-8v-4h8zm-18.52 5.2l-2.91-2.75 14.06-14.81 2.9 2.74L38.48 46.2zM36 54h4v8h-4v-8zm4-22h-4v-8h4v8zm-21 9h8v4h-8v-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B4_Chronometer.1c8b1511.svg";
export { SvgB4Chronometer as ReactComponent };